import React from 'react'
import { Box } from '@mui/material'
import { advancedColors } from '../../../theme'
import { attachmentKind, MessageAttachment } from '../types'
import FileAttachmentRow from './FileAttachmentRow'

const GRID_MAX_WIDTH = 368

const placeholderSx = { borderRadius: 1, backgroundColor: advancedColors.grayLightLabel }

const MessageAttachments = ({ attachments }: { attachments: MessageAttachment[] }) => {
  const images = attachments.filter((attachment) => attachmentKind(attachment) === 'image')
  const files = attachments.filter((attachment) => attachmentKind(attachment) === 'file')

  return (
    <>
      {images.length === 1 && <SingleImage attachment={images[0]} />}

      {images.length > 1 && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 0.5,
            width: '100%',
            maxWidth: GRID_MAX_WIDTH,
          }}
        >
          {images.map((attachment) => (
            <ImageTile key={attachment.fileID} attachment={attachment} />
          ))}
        </Box>
      )}

      {files.map((attachment) => (
        <FileAttachmentRow key={attachment.fileID} attachment={attachment} />
      ))}
    </>
  )
}

const SingleImage = ({ attachment }: { attachment: MessageAttachment }) => {
  if (!attachment.downloadURL) {
    return <Box sx={{ ...placeholderSx, width: 220, aspectRatio: '16 / 9' }} />
  }
  return (
    <Box component="a" href={attachment.downloadURL} target="_blank" rel="noreferrer" sx={{ display: 'block' }}>
      <Box
        component="img"
        src={attachment.downloadURL}
        alt={attachment.filename}
        sx={{ maxWidth: 260, maxHeight: 260, borderRadius: 1, display: 'block' }}
      />
    </Box>
  )
}

const ImageTile = ({ attachment }: { attachment: MessageAttachment }) => {
  if (!attachment.downloadURL) {
    return <Box sx={{ ...placeholderSx, width: '100%', aspectRatio: '16 / 9' }} />
  }
  return (
    <Box component="a" href={attachment.downloadURL} target="_blank" rel="noreferrer" sx={{ display: 'block' }}>
      <Box
        component="img"
        src={attachment.downloadURL}
        alt={attachment.filename}
        sx={{ width: '100%', aspectRatio: '16 / 9', objectFit: 'cover', borderRadius: 1, display: 'block' }}
      />
    </Box>
  )
}

export default MessageAttachments
